import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { i18n } from '../../../../../symphony';
import { Skills } from '../../../../../staticPages/public/SlAILiteracy/components/Skills/Skills';

import s from './AICourseSkills.scss';

export function AICourseSkills(): JSX.Element {
	useStyles(s);

	return (
		<div className="lp-landing-page-ai-course-skills">
			{i18n.language === 'en' && <Skills hideMotivation />}
		</div>
	);
}
